import {
  BooleanField,
  DateField,
  ListDynamicField,
  ListDynamicSource,
  PredefinedRegEx,
  QuestionnaireFieldIdentity,
  StringField,
  ValidationMode,
} from '@g2-shared/api-client/generated/onboarding-app';
import { generateEmptyStringField } from '@g2-shared/features';

export const generateFirstNameFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: undefined as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateMiddleNameFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: undefined as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateParentNameFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: undefined as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateLastNameFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: undefined as unknown as PredefinedRegEx,
  regEx: '',
});

export const generatePersonalIdFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 50,
  predefinedRegEx: undefined as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateDateOfBirthFieldInfo = (): DateField => ({
  fieldType: 'DATE',
  minDate: '',
  maxDate: '',
  outsideRange: false,
  validationMode: ValidationMode.IN_THE_PAST,
});

export const generatePlaceOfBirthFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 70,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateStateOfBirthFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 70,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateCountryOfBirthFieldInfo = (): ListDynamicField => ({
  fieldType: 'DYNAMIC_LIST',
  source: ListDynamicSource.COUNTRY_LIST,
  allowOutOfList: false,
});

export const generateCountryOfIdIssueFieldInfo = (): ListDynamicField => ({
  fieldType: 'DYNAMIC_LIST',
  source: ListDynamicSource.COUNTRY_LIST,
  allowOutOfList: false,
});

export const generateIdNumberFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 50,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateIdTypeFieldInfo = (): ListDynamicField => ({
  fieldType: 'DYNAMIC_LIST',
  source: ListDynamicSource.ID_TYPES,
  allowOutOfList: false,
});

export const generateIdIssuerFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 70,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateIdDateOfIssueFieldInfo = (): DateField => ({
  fieldType: 'DATE',
  minDate: '',
  maxDate: '',
  outsideRange: false,
  validationMode: ValidationMode.IN_THE_PAST,
});

export const generateIdExpiryDateFieldInfo = (): DateField => ({
  fieldType: 'DATE',
  minDate: '',
  maxDate: '',
  outsideRange: false,
  validationMode: ValidationMode.IN_THE_FUTURE,
});

export const generateIdPermanentFieldInfo = (): BooleanField => ({
  fieldType: 'BOOLEAN',
});

export const generateCityOfResidenceFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 70,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateZipFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 20,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateCountryOfResidenceFieldInfo = (): ListDynamicField => ({
  fieldType: 'DYNAMIC_LIST',
  source: ListDynamicSource.COUNTRY_LIST,
  allowOutOfList: false,
});

export const generateMailingAddressFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateEmailFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateResidentFieldInfo = (): BooleanField => ({
  fieldType: 'BOOLEAN',
});

export const generateCitizenshipFieldInfo = (): ListDynamicField => ({
  fieldType: 'DYNAMIC_LIST',
  source: ListDynamicSource.COUNTRY_LIST,
  allowOutOfList: false,
});

export const generateStreetNameFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generatePlaceFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 100,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateResidenceNumberFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 20,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateStateOfResidenceFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generatePhoneNumberFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 50,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateMobileNumberFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 50,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateAdditionalNoteFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 4000,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateMaternalNameFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateOccupationFieldInfo = (): StringField => ({
  fieldType: 'STRING',
  length: 150,
  predefinedRegEx: null as unknown as PredefinedRegEx,
  regEx: '',
});

export const generateFieldInfoByIdentity = (identity: QuestionnaireFieldIdentity) => {
  switch (identity) {
    case QuestionnaireFieldIdentity.firstName:
      return generateFirstNameFieldInfo();
    case QuestionnaireFieldIdentity.middleName:
      return generateMiddleNameFieldInfo();
    case QuestionnaireFieldIdentity.parentName:
      return generateParentNameFieldInfo();
    case QuestionnaireFieldIdentity.lastName:
      return generateLastNameFieldInfo();
    case QuestionnaireFieldIdentity.personalId:
      return generatePersonalIdFieldInfo();
    case QuestionnaireFieldIdentity.dateOfBirth:
      return generateDateOfBirthFieldInfo();
    case QuestionnaireFieldIdentity.placeOfBirth:
      return generatePlaceOfBirthFieldInfo();
    case QuestionnaireFieldIdentity.stateOfBirth:
      return generateStateOfBirthFieldInfo();
    case QuestionnaireFieldIdentity.countryOfBirth:
      return generateCountryOfBirthFieldInfo();
    case QuestionnaireFieldIdentity.countryOfIdIssue:
      return generateCountryOfIdIssueFieldInfo();
    case QuestionnaireFieldIdentity.idNumber:
      return generateIdNumberFieldInfo();
    case QuestionnaireFieldIdentity.idType:
      return generateIdTypeFieldInfo();
    case QuestionnaireFieldIdentity.idIssuer:
      return generateIdIssuerFieldInfo();
    case QuestionnaireFieldIdentity.idDateOfIssue:
      return generateIdDateOfIssueFieldInfo();
    case QuestionnaireFieldIdentity.idExpiryDate:
      return generateIdExpiryDateFieldInfo();
    case QuestionnaireFieldIdentity.idPermanent:
      return generateIdPermanentFieldInfo();
    case QuestionnaireFieldIdentity.cityOfResidence:
      return generateCityOfResidenceFieldInfo();
    case QuestionnaireFieldIdentity.zip:
      return generateZipFieldInfo();
    case QuestionnaireFieldIdentity.countryOfResidence:
      return generateCountryOfResidenceFieldInfo();
    case QuestionnaireFieldIdentity.mailingAddress:
      return generateMailingAddressFieldInfo();
    case QuestionnaireFieldIdentity.email:
      return generateEmailFieldInfo();
    case QuestionnaireFieldIdentity.resident:
      return generateResidentFieldInfo();
    case QuestionnaireFieldIdentity.citizenship:
      return generateCitizenshipFieldInfo();
    case QuestionnaireFieldIdentity.streetName:
      return generateStreetNameFieldInfo();
    case QuestionnaireFieldIdentity.place:
      return generatePlaceFieldInfo();
    case QuestionnaireFieldIdentity.residenceNumber:
      return generateResidenceNumberFieldInfo();
    case QuestionnaireFieldIdentity.stateOfResidence:
      return generateStateOfResidenceFieldInfo();
    case QuestionnaireFieldIdentity.phoneNumber:
      return generatePhoneNumberFieldInfo();
    case QuestionnaireFieldIdentity.mobileNumber:
      return generateMobileNumberFieldInfo();
    case QuestionnaireFieldIdentity.additionalNote:
      return generateAdditionalNoteFieldInfo();
    case QuestionnaireFieldIdentity.maternalName:
      return generateMaternalNameFieldInfo();
    case QuestionnaireFieldIdentity.occupation:
      return generateOccupationFieldInfo();
    default:
      return generateEmptyStringField();
  }
};
